import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import { twMerge } from 'tailwind-merge';
type ActionType = 'hover' | 'click' | 'focus';

export interface TooltipProps {
  trigger?: ActionType | ActionType[];
  defaultVisible?: boolean;
  visible?: boolean;
  placement?:
    | 'left'
    | 'top'
    | 'bottom'
    | 'right'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'rightBottom'
    | 'leftBottom'
    | 'leftTop'
    | 'rightTop';
  onVisibleChange?: (visible: boolean) => void;
  afterVisibleChange?: (visible: boolean) => void;
  overlay: React.ReactNode;
  overlayStyle?: React.CSSProperties;
  overlayClassName?: string;
  prefixCls?: string;
  mouseEnterDelay?: number;
  mouseLeaveDelay?: number;
  showArrow?: boolean;
  children: any;
  overlayInnerStyle?: React.CSSProperties;
  zIndex?: number;
  className?: string;
  align?: any;
  childContainerClass?: string;
  containerClass?: string;
}
const Index = ({
  children,
  overlay,
  trigger = 'click',
  placement = 'bottom',
  showArrow = true,
  ...props
}: TooltipProps) => {
  return (
    <div
      className={twMerge(
        'tooltip-container',
        props.containerClass ?? props.containerClass
      )}
    >
      <Tooltip
        trigger={trigger}
        placement={placement}
        overlay={<div>{overlay}</div>}
        showArrow={showArrow}
        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
        overlayClassName={`rc-tooltip-width`}
        getTooltipContainer={(d: any) => d}
        {...props}
      >
        <div
          className={twMerge(
            'w-fit',
            props.childContainerClass ?? props.childContainerClass
          )}
        >
          {children}
        </div>
      </Tooltip>
    </div>
  );
};

export default Index;
